const EditTypeEnum = Object.freeze({
    DEFAULT: "",
    NAME: "name",
    EMAIL: "email",
    PASSWORD: "password",
    ROLE: "role",
});
export default EditTypeEnum;